import { CreateBugReportModal } from '@features/BugReport/components/CreateBugReportModal/CreateBugReportModal.main';
import { useCallback, useRef } from 'react';

import type { CreateBugReportModalApi } from '@features/BugReport/components/CreateBugReportModal/types';

type UseBugReportArgs = {
  setIsHelpBoxOpened: (newStatus: boolean) => void;
};

export const useBugReport = ({ setIsHelpBoxOpened }: UseBugReportArgs) => {
  const createBugReportModalRef = useRef<CreateBugReportModalApi>(null);
  const renderCreateBugReportModal = useCallback(
    () => <CreateBugReportModal ref={createBugReportModalRef} />,
    []
  );

  return {
    openCreateBugReportModal: () => {
      setIsHelpBoxOpened(false);
      createBugReportModalRef?.current?.open();
    },
    renderCreateBugReportModal,
  };
};
